import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import {
  getDepartmentListPath,
  createDepartmentPath,
} from "../../services/config";
import { config } from "../../services/configHeader";
const user = JSON.parse(localStorage.getItem("user_data")) || {}

const accountType = user?.account_type;
const baseUrl = process.env.REACT_APP_BASE_URI;

const normalizeThunkError = (error, fallbackMessage = "Request failed") => ({
  status: error?.response?.status || error?.status || 500,
  response: {
    data: {
      ...(error?.response?.data || {}),
      message:
        error?.response?.data?.message ||
        error?.message ||
        fallbackMessage,
      data: error?.response?.data?.data || null,
    },
  },
  message: error?.message || fallbackMessage,
});

let initialState = {
  depLoading: false,
  depSuccess: false,
  depError: false,
  depMessage: null,

  depGetLoading: false,
  depGetSuccess: false,
  depGetError: false,
  depGetMessage: null,
  depGetData: null,
};


export const fetchDepartmentData = createAsyncThunk(
  "fetchDepartmentData",
  async (userId) => {
    return await axios
      .get(`${baseUrl}${getDepartmentListPath}${userId}`, config)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        if (!navigator.onLine) {
          let data = {
            response: {
              data: [],
              message: "No Internet Connection Found",
              success: false,
            },
            data: {
              data: [],
              message: "No Internet Connection Found",
              success: false,
            },
          };
          return data;
        } else {
          return normalizeThunkError(error, "Failed to load departments");
        }
      });
  }
);

export const createDepartment = createAsyncThunk(
  "createDepartment",
  async (data) => {
    const result = {
      data: {
        message: "Sorry, you can only view the data, not create it.",
        data: [],
      },
    };
    return parseInt(accountType) === 2
      ? result
      : await axios
          .post(`${baseUrl}${createDepartmentPath}`, data, config)
          .then((response) => {
            return response;
          })
          .catch((error) => {
            if (!navigator.onLine) {
              let data = {
                response: {
                  data: [],
                  message: "No Internet Connection Found",
                  success: false,
                },
                data: {
                  data: [],
                  message: "No Internet Connection Found",
                  success: false,
                },
              };
              return data;
            } else {
              return normalizeThunkError(error, "Failed to save department");
            }
          });
  }
);

const departmentSlice = createSlice({
  name: "department",
  initialState,

  reducers: {
    initDepartState: (state) => {
      state.depLoading = false;
      state.depSuccess = false;
      state.depError = false;
      state.depMessage = null;

      state.depGetLoading = false;
      state.depGetSuccess = false;
      state.depGetError = false;
      state.depGetMessage = null;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(fetchDepartmentData.pending, (state, action) => {
      state.depGetLoading = true;
      state.depGetSuccess = false;
      state.depGetError = false;
      state.depGetMessage = null;
      state.depGetData = null;
    });
    builder.addCase(fetchDepartmentData.fulfilled, (state, action) => {
      const payload = action.payload || {};
      const body = payload.data || {};
      const responseBody = payload.response?.data || {};
      if (!payload?.data && !payload?.response?.data) {
        state.depGetLoading = false;
        state.depGetSuccess = false;
        state.depGetError = true;
        state.depGetMessage = payload?.message || "Failed to load departments";
        state.depGetData = null;
        return;
      }
      const status = body.status;
      if (payload.status == 200 || payload.status == "200") {
        if (status == true || status == "true") {
          state.depGetLoading = false;
          state.depGetSuccess = true;
          state.depGetError = false;
          state.depGetMessage = body.message || body.msg || null;
          state.depGetData = body.data || null;
        } else {
          state.depGetLoading = false;
          state.depGetSuccess = false;
          state.depGetError = true;
          state.depGetMessage = body.message || body.msg || "Failed to load departments";
          state.depGetData = null;
        }
      } else {
        state.depGetLoading = false;
        state.depGetSuccess = false;
        state.depGetError = true;
        state.depGetMessage = responseBody.message || body.message || body.msg || payload.message || "Failed to load departments";
        state.depGetData = null;
      }
    });
    builder.addCase(fetchDepartmentData.rejected, (state, action) => {
      state.depGetLoading = false;
      state.depGetSuccess = false;
      state.depGetError = true;
      state.depGetMessage = action.payload?.response?.data?.message || action.error?.message || "Failed to load departments";
      state.depGetData = null;
    });
    // To create department
    builder.addCase(createDepartment.pending, (state, action) => {
      state.depLoading = true;
      state.depSuccess = false;
      state.depError = false;
      state.depMessage = null;
    });
    builder.addCase(createDepartment.fulfilled, (state, action) => {
      const payload = action.payload || {};
      const body = payload.data || {};
      const responseBody = payload.response?.data || {};
      state.depLoading = false;
      state.depSuccess = (payload.status == 200 || payload.status == 201 || accountType == 2) ? accountType != 2 : false;
      state.depError = accountType == 2 || !(payload.status == 200 || payload.status == 201);
      state.depMessage = body.message || body.msg || responseBody.message || payload.message || null;
    });
    builder.addCase(createDepartment.rejected, (state, action) => {
      state.depLoading = false;
      state.depSuccess = false;
      state.depError = true;
      state.depMessage = action.payload?.response?.data?.message || action.error?.message || "Failed to save department";
    });
  },
});

export const { initDepartState } = departmentSlice.actions;
export default departmentSlice.reducer;
